export const validatePassword = () => (value: string) => {
  if (!value) return true;

  if (value.length < 10) return '비밀번호는 10자 이상이어야 합니다.';

  const hasLetter = /[a-zA-Z]/.test(value);
  const hasNumber = /[0-9]/.test(value);
  const hasSpecial = /[^a-zA-Z0-9]/.test(value);

  if ([hasLetter, hasNumber, hasSpecial].filter(Boolean).length < 2) {
    return '문자, 숫자, 특수문자 중 2가지 이상 조합하세요.';
  }

  return true;
};

export const isValidPassword = (value: string) => {
  if (!value) return false;
  if (value.length < 10) return false;

  const hasLetter = /[a-zA-Z]/.test(value);
  const hasNumber = /[0-9]/.test(value);
  const hasSpecial = /[^a-zA-Z0-9]/.test(value);

  return [hasLetter, hasNumber, hasSpecial].filter(Boolean).length >= 2;
};
